import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PAGES_DATA, USER_TYPE } from '../utils/constants';

const usePremiumSelectAdminPageAccess = (user) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user?.type !== USER_TYPE.PREMIUM_SELECT_ADMIN || !Array.isArray(user?.accessLevels)) {
      return;
    }

    const currentPage = PAGES_DATA.find(page =>
      page?.link === location?.pathname ||
      page?.submenu?.some(sub => sub.link === location?.pathname)
    );

    const hasAccess = currentPage?.roles?.some(role =>
      user.accessLevels.includes(role)
    );

    if (location?.pathname !== '/' && !hasAccess) {
      navigate('/Unauthorized');
    }
  }, [user, location.pathname, navigate]);
};

export default usePremiumSelectAdminPageAccess;
